import { memo } from 'react';
import { BzTabsContent, BzTabsContainer } from '../../../components'


const Notes = ({ notesTabs, activeTab }) => {

    return (
        <div className='sticky-notes-height'>
            <BzTabsContainer>
                {notesTabs.map((each, i) => (
                    <BzTabsContent key={i} showDefault={each.tabKey === activeTab} isActive={each.tabKey === activeTab} tabKey={each.tabKey}>{each.tabContent}</BzTabsContent>
                ))}
            </BzTabsContainer>
        </div>
    );
};

export default memo(Notes);